/**
 * 拖拽上传自定义指令 v-drop-upload
 *
 * 使用方式：
 * <div v-drop-upload="handleFiles">拖放区域</div>
 *
 * 回调函数签名：(files: File[]) => void
 */
export default {
  mounted(el, binding) {
    const handler = binding.value;

    if (typeof handler !== "function") {
      console.warn("v-drop-upload expects a function as value");
      return;
    }

    // 阻止默认拖拽行为
    const preventDefault = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };

    // 拖拽进入时添加高亮样式
    const handleDragEnter = (e) => {
      preventDefault(e);
      el.classList.add("drop-upload-active");
    };

    // 拖拽离开时移除高亮样式
    const handleDragLeave = (e) => {
      preventDefault(e);
      if (!el.contains(e.relatedTarget)) {
        el.classList.remove("drop-upload-active");
      }
    };

    // 拖拽经过时保持高亮
    const handleDragOver = (e) => {
      preventDefault(e);
      el.classList.add("drop-upload-active");
    };

    // 放置时处理文件
    const handleDrop = (e) => {
      preventDefault(e);
      el.classList.remove("drop-upload-active");

      const files = Array.from(e.dataTransfer?.files || []);
      if (files.length > 0) {
        handler(files);
      }
    };

    // 保存事件处理函数以便卸载时移除
    el._dropUploadHandlers = {
      dragenter: handleDragEnter,
      dragleave: handleDragLeave,
      dragover: handleDragOver,
      drop: handleDrop
    };

    // 绑定事件
    el.addEventListener("dragenter", handleDragEnter);
    el.addEventListener("dragleave", handleDragLeave);
    el.addEventListener("dragover", handleDragOver);
    el.addEventListener("drop", handleDrop);

    // 添加基础样式
    const style = document.createElement("style");
    style.textContent = `
      .drop-upload-active {
        // border: 2px dashed #409eff !important;
        background-color: rgba(64, 158, 255, 0.05) !important;
        cursor: copy !important;
        position:relative;
        
      }
      .drop-upload-active::before {
        content: "";
        position: absolute;
        top: -10;
        left: -10;
        bottom: -10;
        right: -10;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 1) !important;
        cursor: copy !important;
        z-index: 999;
        filter: blur(5px);
      }
      .drop-upload-active::after {
        content: "释放以上传";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #409eff;
        font-size: 14px;
        z-index: 1000;
        width: 100%;
        height: 100%;
        border: 1px dashed #409eff !important;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    `;
    document.head.appendChild(style);
    el._dropUploadStyle = style;
  },

  unmounted(el) {
    // 移除事件监听
    if (el._dropUploadHandlers) {
      const { dragenter, dragleave, dragover, drop } = el._dropUploadHandlers;
      el.removeEventListener("dragenter", dragenter);
      el.removeEventListener("dragleave", dragleave);
      el.removeEventListener("dragover", dragover);
      el.removeEventListener("drop", drop);
      delete el._dropUploadHandlers;
    }

    // 移除样式
    if (el._dropUploadStyle) {
      document.head.removeChild(el._dropUploadStyle);
      delete el._dropUploadStyle;
    }

    // 移除高亮类
    el.classList.remove("drop-upload-active");
  }
};
